import { Flex, Th, Thead, Tr } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { ExpandChevron } from "../../elements/ExpandChevron";
import { useComparePageContext } from "../../shared/state/ComparePageContext";

interface Props {
  isOpen: boolean;
  onToggle: () => void;
}

export function CategoryHeader({
  isOpen,
  onToggle,
  children,
}: PropsWithChildren<Props>) {
  const { scenarios } = useComparePageContext();

  return (
    <Thead>
      <Tr>
        <Th onClick={onToggle}>
          <Flex>
            <ExpandChevron isOpen={isOpen} />
            {children}
          </Flex>
        </Th>
        <Th>{children}</Th>
        {scenarios.map((c) => (
          <Th key={c.id}>{children}</Th>
        ))}
      </Tr>
    </Thead>
  );
}
